<template>
  <div>
    <div class="w3-container">
      <div class="headerGridCMS w3-hide-print">
        <div>
          <header>
            <h2><template v-if="$route.params.slug">Edit</template><template v-else>New</template> Custom Page</h2>
          </header>
        </div>
        <div>
          <button class='w3-button w3-right w3-small vmiddle w3-red' style="margin-left:8px;" @click="exitCustomPage()">Exit</button>
          <button class='w3-button w3-right w3-small vmiddle' :class="saving || saved ? 'w3-dark-teal' : 'w3-teal'" :disabled="saving || saved" @click="saveContent()"><span v-if="!saved">Save Custom Page</span><span v-if="saved">Custom Page Saved</span></button>
        </div>
      </div>
      <div class="inputCard">
        <header class="w3-left-align">Main</header>
        <div class="content">
          <!-- Name -->
          <div class="cardRow w3-padding-8">
            <label>Name</label>
            <input v-model="page.name" placeholder="My Custom Page" class="w3-input w3-border" />
          </div>
          <!-- Link -->
          <div class="cardRow w3-padding-8">
            <label>Link</label>
            <input v-model="page.link" placeholder="page.php" class="w3-input w3-border" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Editor from '@tinymce/tinymce-vue'
var dataStore = require('../../dataStore').default

export default {
  name: 'cmscustompagessdetail',
  data() {
    return {
      state: dataStore.state,
      page: null,
      saving: false,
      saved: false
    }
  },
  components: {
    'tinymce-editor': Editor
  },
  created() {
    this.initCustomPage()
    if (this.$route.params.name) {
      for (let savedCustomPage of this.state.siteData.pages.custom.items) {
        if (this.$route.params.name === savedCustomPage.name) {
          this.page = savedCustomPage
          break
        }
      }
    }
  },
  methods: {
    initCustomPage() {
      this.page = {
        name: '',
        link: ''
      }
    },
    saveContent() {
      let loopIndex = 0
      let found = false
      for (let page of this.state.siteData.pages.custom.items) {
        if (page.name === this.page.name) {
          if (!confirm('Custom Page with this Name already exists, overwrite?')) {
            return
          } else {
            found = true
            break
          }
        }
        loopIndex++
      }
      if (found) {
        this.state.siteData.pages.custom.items[loopIndex] = this.page
      } else {
        this.state.siteData.pages.custom.items.push(this.page)
      }
      this.saving = true
      dataStore.saveSiteData().then((res) => {
        this.saving = false
        if (res === 'success') {
          this.$router.replace({name: 'cmsSettings', params: {page: 'pages'}})
        }
      })
    },
    exitCustomPage() {
      this.initCustomPage()
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
  .buttons {text-align: right;}
  header.w3-left-align {padding-left:12px;}

  .customPageDetailGrid {display:grid; grid-template-columns: 3fr 1fr; grid-gap: 8px;}
</style>



// WEBPACK FOOTER //
// src/components/cms/cmsCustomPagesDetail.vue